<template>
  <div class="project-home-w">
    <div class="project-content" v-if="!showProjectSetting">
      <!-- Breadcrumb -->
      <div class="breadcrumb-w" v-if="!showOverviewList">
        <div class="back-w" @click="backFormerLevel()">
          <i class="el-icon-back"></i>
        </div>
        <div style="display: inline-block">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <span
                class="bread-item"
                style="color: #409eff; font-weight: bold"
                @click="navTo('HOME')">
                Home
              </span>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="projectInfo !== null">
              <span
                class="bread-item"
                :style="(currentFolder !== null || currentItem !== null) ? 'color: #409eff; font-weight: bold':'font-weight: bold'"
                @click="navTo('PROJECT')">
                {{projectInfo.name}}
              </span>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentFolder !== null">
              <span
                class="bread-item"
                :style="currentItem !== null ? 'color: #409eff; font-weight: bold':'font-weight: bold'"
                @click="navTo('FOLDER')">
                {{currentFolder.name}}
              </span>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentItem !== null">
              <span style="font-weight: bold" class="bread-item">{{currentItem.name}}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>

      <!-- Project Level Buttons -->
      <div class="project-buttons" :style="showOverviewList ? 'padding-top: 0' : ''">
        <div>
          <i class="project-button material-icons" @click="showProjectSetting = true">settings</i>
          <i
            class="project-button material-icons"
            v-if="overviewItems && overviewItems.length > 0 && !showIndependentItemPage"
            @click="showOverviewList = !showOverviewList, currentItem = null"
            :style="showOverviewList ? 'color: #409eff' : ''">
            {{showOverviewList ? 'exit_to_app' : 'print'}}
          </i>
          <i
            class="project-button material-icons"
            v-if="showIndependentItemPage"
            @click="showIndependentItemPage = false"
            style="color: #409eff">
            exit_to_app
          </i>
        </div>
        <div class="section-title" v-if="showOverviewList">Item List</div>
      </div>

      <!-- Project list wrapper (folder mode) -->
      <div class="project-list-w" v-if="!showOverviewList">
        <!-- No folders/items -->
        <div class="no-project" v-if="noItemAndFolderInProject">
          <div>
            <img
              src="../assets/files.svg"
              alt="blank status"
              width="40%"
              style="margin-bottom: 12px">
            <div>No folders/items found</div>
          </div>
        </div>
        <!-- No item in a specific folder -->
        <div class="no-project" v-if="noItemInFolder">
          <div>
            <img
              src="../assets/files.svg"
              alt="blank status"
              width="40%"
              style="margin-bottom: 12px">
            <div>No items in this folder</div>
          </div>
        </div>
        <!-- Multiple lists -->
        <div
          class="project-list"
          v-if="!noItemAndFolderInProject && !noItemInFolder && !currentItem">
          <!-- Folder List -->
          <div class="folder-list-w" v-if="currentFolder === null && currentItem === null">
            <div class="section-title" v-show="folderList && folderList.length !== 0">Folders</div>
            <looping-rhombuses-spinner
              style="margin-left: 2vw"
              v-if="folderLoading"
              :animation-duration="2500"
              :rhombus-size="15"
              color="#f57c00"/>
            <div class="folder-list" v-show="!folderLoading">
              <div
                class="project-card"
                v-for="folder in folderList"
                :key="folder.id"
                @click="toFolder(folder)">
                <div class="project-name" style="position: relative;">
                  <div class="project-name-text">
                    <span class="folder-name-text">{{folder.name}}</span>
                    <span class="folder-size-bubble">{{folderSizes[folder.id]}}</span>
                  </div>
                  <div class="more-button">
                    <i class="material-icons" @click.stop="openFolderMenu(folder)">more_vert</i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Item List -->
          <div class="item-list-w" v-if="currentItem === null">
            <div class="section-title" v-show="itemList && itemList.length !== 0">Items</div>
            <looping-rhombuses-spinner
              style="margin-left: 2vw"
              v-if="itemLoading"
              :animation-duration="2500"
              :rhombus-size="15"
              color="#f57c00"/>
            <div class="item-list" v-show="!itemLoading">
              <div
                class="project-card"
                v-for="item in itemList"
                :key="item.id"
                @click="toItem(item)">
                <div class="project-name" style="position: relative;">
                  <div class="project-name-text">
                    <span
                      style="color:#1e88e5; margin-right: 6px;">
                      {{10 > item.index ? '0' : ''}}{{item.index}}
                    </span>
                    <span class="item-name-text">{{item.name}}</span>
                  </div>
                  <div class="more-button">
                    <i class="material-icons" @click.stop="openItemMenu(item)">more_vert</i>
                  </div>
                </div>

                <div class="last-edit-by" v-if="item.lastEditOn !== null">
                  <div style="color: #808080;">Last edit by</div>
                  <div
                    style="font-size: 12px;">{{item.lastEditBy.name.first}}, {{formatTime(item.lastEditOn)}}</div>
                </div>
                <div class="last-edit-by" v-else>
                  <div style="color: #808080;">Create by</div>
                  <div
                    style="font-size: 12px;">
                    {{item.createBy.name.first}}, {{formatTime(item.createOn)}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Offline Folders-->
          <div
            class="folder-list-w"
            v-if="currentFolder === null && currentItem === null && offlineFolderList && offlineFolderList.length > 0">
            <div class="section-title">Offline Folders</div>
            <!-- <looping-rhombuses-spinner style="margin-left: 2vw" v-if="folderLoading" :animation-duration="2500" :rhombus-size="15" color="#f57c00"/> -->
            <div class="folder-list">
              <div
                class="project-card"
                v-for="folder in offlineFolderList"
                v-show="folder.open"
                :key="folder.id"
                @click="toFolder(folder)">
                <div class="project-name" style="position: relative;">
                  <div class="project-name-text">
                    <span class="folder-name-text">{{folder.name}}</span>
                    <span class="folder-size-bubble">{{folderSizes[folder.id]}}</span>
                  </div>
                  <div class="more-button">
                    <i class="material-icons" @click.stop="openFolderMenu(folder)">more_vert</i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Offline Items-->
          <div
            class="folder-list-w"
            v-if="currentItem === null && offlineItemList && offlineItemList.length > 0">
            <div class="section-title">Offline Items</div>
            <!-- <looping-rhombuses-spinner style="margin-left: 2vw" v-if="folderLoading" :animation-duration="2500" :rhombus-size="15" color="#f57c00"/> -->
            <div class="folder-list">
              <div
                class="project-card"
                v-for="item in offlineItemList"
                v-show="item.open && item.folderId === currentFolderId"
                :key="item.id"
                @click="toItem(item)">
                <div class="project-name" style="position: relative;">
                  <div class="project-name-text">
                    <span
                      style="color:#1e88e5; margin-right: 6px;">{{10 > item.index ? '0' : ''}}{{item.index}}</span>
                    <span class="item-name-text">{{item.name}}</span>
                  </div>
                  <div class="more-button">
                    <i class="material-icons" @click.stop="openItemMenu(item)">more_vert</i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Images -->
          <div class="folder-list-w" v-if="currentItem === null && currentFolder !== null">
            <div class="section-title">Images</div>
            <div class="image-part" v-if="currentFolder.images.length > 0">
              <vue-gallery :images="currentFolder.images" :index="galleyIndex" @close="galleyIndex = null"></vue-gallery>
              <el-carousel
                v-if="currentFolder.images.length !== 0"
                height="400px"
                :interval="5000"
                arrow="always"
                style="margin-top: 20px;"
              >
                <el-carousel-item v-for="(image,index) in currentFolder.images" :key="index">
                  <div
                    class="image-light-box"
                    @click="galleyIndex = index"
                    :style="{ backgroundImage: 'url(' + image + ')' }"
                  ></div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>

        <!-- The item page -->
        <item-page
          v-if="currentItem !== null"
          :currentItem="currentItem"
          v-on:refresh-item="refreshItem"></item-page>

        <!-- Add folder/item button on desktop -->
        <transition name="desktop-add" v-if="currentItem === null">
          <div class="desktop-buttons" v-if="showDesktopAdd">
            <div class="desktop-add" @click="addNew(), showDesktopAdd = false">
              <img src="../assets/folder.svg" alt="desktop add button" width="42px">
              <div style="font-size: 11px;">New Folder/Item</div>
            </div>
          </div>
        </transition>

        <!-- Add folder/item button on mobile -->
        <div class="buttons" v-if="currentItem === null">
          <div class="mobile-add">
            <div class="add-float-button" @click="addNew()">
              <img src="../assets/add (3).svg" alt="add float icon" width="24px">
            </div>
          </div>
        </div>

        <!-- Add folder form pop up -->
        <transition name="pop-w-animate">
          <div class="pop-w" v-if="showAddPopW" @click="showAddPopFunc(), showAddPop = false"></div>
        </transition>
        <div class="pop">
          <transition name="pop-card">
            <add-folder-item-pop
              v-if="showAddPop"
              v-on:close-add-pop="showAddPopFunc(), showAddPop = false"
              :folder="currentFolder"
              :newItemIndex="nextItemIndex"></add-folder-item-pop>
          </transition>
        </div>

        <!-- Rename folder form pop up -->
        <transition name="pop-w-animate">
          <div class="pop-w" v-if="showRenameFolderPop" @click="cancelRenameFolder()"></div>
        </transition>
        <div class="pop">
          <transition name="pop-card">
            <div class="project-pop-card" v-if="showRenameFolderPop">
              <div class="title-w">
                <div class="title">Rename Folder</div>
                <div class="close-pop">
                  <i class="el-icon-close" @click="cancelRenameFolder()"></i>
                </div>
              </div>
              <el-input v-model="newFolderName" clearable></el-input>
              <div style="margin-top: 24px; text-align: center">
                <el-button
                  type="primary"
                  round
                  @click="submitRenameFolder()"
                  :disabled="!newFolderName">Save</el-button>
                <el-button round @click="cancelRenameFolder()">Cancel</el-button>
              </div>
            </div>
          </transition>
        </div>

        <!-- Delete folder form pop up -->
        <transition name="pop-w-animate">
          <div class="pop-w" v-if="showDeleteFolderPop" @click="cancelDeleteFolder()"></div>
        </transition>
        <div class="pop">
          <transition name="pop-card">
            <div class="project-pop-card" v-if="showDeleteFolderPop">
              <div class="title-w">
                <div class="title">Delete Folder {{ folderMenuTarget.name }}</div>
                <div class="close-pop">
                  <i class="el-icon-close" @click="cancelDeleteFolder()"></i>
                </div>
              </div>
              <div style="margin-top: 24px; text-align: center">
                <el-button type="danger" round @click="submitDeleteFolder()">Delete</el-button>
                <el-button round @click="cancelDeleteFolder()">Cancel</el-button>
              </div>
            </div>
          </transition>
        </div>

        <!-- Delete item form pop up -->
        <transition name="pop-w-animate">
          <div class="pop-w" v-if="showDeleteItemPop" @click="cancelDeleteItem()"></div>
        </transition>
        <div class="pop">
          <transition name="pop-card">
            <div class="project-pop-card" v-if="showDeleteItemPop">
              <div class="title-w">
                <div class="title">Delete Item {{ itemMenuTarget.name }}</div>
                <div class="close-pop">
                  <i class="el-icon-close" @click="cancelDeleteItem()"></i>
                </div>
              </div>
              <div style="margin-top: 24px; text-align: center">
                <el-button type="danger" round @click="submitDeleteItem()">Delete</el-button>
                <el-button round @click="cancelDeleteItem()">Cancel</el-button>
              </div>
            </div>
          </transition>
        </div>

        <!-- Slide up menu for a folder -->
        <div class="slide-up-w" v-if="showFolderMenu">
          <slide-up-menu
            :target="{type: 'FOLDER', name: folderMenuTarget.name, index: ''}"
            v-on:close-menu="resetFolderMenu()">
            <slide-up-button
              type="normal"
              icon="create"
              @click.native="renameFolder()">Rename Folder</slide-up-button>
            <slide-up-button
              type="danger"
              icon="delete"
              @click.native="deleteFolder()">Delete Folder</slide-up-button>
          </slide-up-menu>
        </div>

        <!-- Slide up menu for an item -->
        <div class="slide-up-w" v-if="showItemMenu">
          <slide-up-menu
            :target="{type: 'ITEM', name: itemMenuTarget.name, index: itemMenuTarget.index < 10 ? '0'+itemMenuTarget.index : itemMenuTarget.index}"
            v-on:close-menu="resetItemMenu()">
            <slide-up-button type="normal" icon="create" @click="editItemMenu()">Edit Item</slide-up-button>
            <slide-up-button type="danger" icon="delete" @click="deleteItem()">Delete Item</slide-up-button>
          </slide-up-menu>
        </div>
      </div>

      <!-- Item Overview List (list mode)-->
      <div v-if="showOverviewList">
        <item-overview
          :folder-names="folderNames"
          :items="overviewItems"
          v-on:to-item="activeIndependentItemPage"
          v-if="!showIndependentItemPage"></item-overview>
        <!-- <div
          v-if="currentItem !== null && showIndependentItemPage"
          @click="showIndependentItemPage = false"
          class="section-title" style="color: #333; line-height: 32px">Back</div>-->

        <!-- Independent Item Detail Page, only show if showOverviewList is visible-->
        <item-page
          v-if="currentItem !== null && showIndependentItemPage"
          :currentItem="currentItem"
          v-on:refresh-item="refreshItem"></item-page>
      </div>
    </div>
    <project-setting
      v-if="showProjectSetting"
      v-on:close="showProjectSetting = false"
      :project="projectInfo"></project-setting>
  </div>
</template>

<script>
import { LoopingRhombusesSpinner } from 'epic-spinners'
import AddFolderItemPop from './AddFolderItemPop.vue'
import SlideUpButton from './SlideUpButton.vue'
import SlideUpMenu from './SlideUpMenu.vue'
import ItemPage from './ItemPage.vue'
import ItemOverview from './ItemOverview.vue'
import ProjectSetting from './ProjectSetting.vue'

export default {
  name: 'ProjectHome',
  components: {
    ItemPage,
    AddFolderItemPop,
    LoopingRhombusesSpinner,
    SlideUpButton,
    SlideUpMenu,
    ItemOverview,
    ProjectSetting
  },
  created: function () {
    this.currentFolderCopy = JSON.parse(
      JSON.stringify(this.currentFolder || null)
    )
  },
  data () {
    return {
      currentItem: null, // the item to show the detail info // the folder obj of current folder, null if at the root
      loadingData: false,
      openEditorError: '',
      itemCardHidden: null,
      refreshingItem: false,
      folderMenuTarget: null,
      itemMenuTarget: null,
      showRenameFolderPop: false,
      showDeleteFolderPop: false,
      newFolderName: '',
      showDeleteItemPop: false,
      showFolderMenu: false,
      showItemMenu: false,

      showDesktopAdd: true,
      showAddPopW: false,
      showAddPop: false,
      openIndex: null,
      currentFolderCopy: null,

      showOverviewList: false,
      showIndependentItemPage: false,
      showProjectSetting: false,

      galleyIndex: null
    }
  },
  computed: {
    canAdd: function () {
      if (
        this.projectInfo.status !== 'MEASUREMENT' &&
        !this.userPermits.ITEM_FORCE_CREATE &&
        !this.userPermits.FOLDER_FORCE_CREATE
      ) {
        return false
      }
      return true
    },
    projectInfo: function () {
      return this.$store.state.currentProject
    },
    userPermits: function () {
      // eslint-disable-next-line no-mixed-operators
      return (
        (this.$store.getters.currentUserInfo &&
          this.$store.getters.currentUserInfo.permits) ||
        null
      )
    },
    folderList: function () {
      return this.$store.state.currentFolders.filter(folder => {
        return folder.open
      })
    },
    offlineFolderList: function () {
      return this.$store.state.currentOfflineFolders.filter(folder => {
        return folder.open
      })
    },
    folderNames: function () {
      let names = {}
      for (let folder of this.folderList) {
        names[folder.id] = folder.name
      }
      for (let folder in this.offlineFolderList) {
        names[folder.id] = folder.name
      }
      return names
    },
    fullOfflineItemList: function () {
      return this.$store.getters.fullOfflineItemList
    },
    fullItemList: function () {
      return this.$store.getters.fullItemList
    },
    itemList: function () {
      return this.$store.getters.itemList
    },
    offlineItemList: function () {
      return this.$store.getters.offlineItemList
    },
    projectLoading: function () {
      return this.$store.state.projectLoading
    },
    itemLoading: function () {
      return this.$store.state.itemsLoading
    },
    folderLoading: function () {
      return this.$store.state.foldersLoading
    },

    currentItemStr: function () {
      if (!this.currentItem || !this.currentItem.questions) {
        return []
      }
      let currentItemStr = []
      let questions = this.currentItem.questions

      for (var i = 0; i < questions.length; i++) {
        let value = null
        if (typeof questions[i].value !== 'string') {
          if (questions[i].value[0] === true) {
            value = 'Yes - ' + questions[i].value.slice(1).join(' - ')
          } else if (questions[i].value[0] === false) {
            value = 'No - ' + questions[i].value.slice(1).join(' - ')
          } else {
            value = questions[i].value.join(' - ')
          }
        } else {
          value = questions[i].value
        }
        let id = questions[i].id
        let name = questions[i].name
        // console.log(name);

        currentItemStr.push({
          id: id,
          name: name,
          value: value
        })
      }
      // console.log(this.currentItem.questions);
      return currentItemStr
    },
    currentFolder: function () {
      return this.$store.state.currentFolder
    },
    currentFolderId: function () {
      return this.currentFolder && this.currentFolder.id
    },
    loading: function () {
      return this.projectLoading || this.itemLoading || this.folderLoading
    },
    noItemAndFolderInProject: function () {
      // only possible return true at root
      if (
        this.currentFolder !== null ||
        this.currentItem !== null ||
        !this.folderList ||
        !this.itemList ||
        !this.offlineItemList ||
        !this.offlineFolderList
      ) {
        return false
      }
      if (
        this.folderList.length +
          this.itemList.length +
          this.offlineItemList.length +
          this.offlineFolderList.length ===
        0
      ) {
        return true
      } else {
        return false
      }
    },
    noItemInFolder: function () {
      // always return false if currently not in folder view
      if (
        this.currentFolder === null ||
        this.currentItem !== null ||
        !this.itemList ||
        !this.offlineItemList
      ) {
        return false
      }
      if (this.itemList.length + this.offlineItemList.length + this.currentFolder.images.length === 0) {
        return true
      } else {
        return false
      }
    },
    nextItemIndex: function () {
      return this.$store.getters.nextItemIndex
    },
    folderSizes: function () {
      let counts = {
        root: 0
      }
      for (let folder of this.offlineFolderList) {
        counts[folder.id] = 0
      }
      for (let folder of this.folderList) {
        counts[folder.id] = 0
      }
      for (let item of this.fullOfflineItemList) {
        // console.log(item)
        if (item.folderId) {
          counts[item.folderId] = counts[item.folderId] + 1
          // console.log('counts', counts)
        } else {
          counts.root = counts.root + 1
        }
      }
      for (let item of this.fullItemList) {
        // console.log(item)
        if (item.folderId) {
          counts[item.folderId] = counts[item.folderId] + 1
        } else {
          counts.root = counts.root + 1
        }
      }
      return counts
    },
    overviewItems: function () {
      let itemList = []
      if (this.currentFolder === null) {
        itemList = this.fullItemList.map(item => {
          item.online = true
          return item
        })
        itemList.concat(
          this.fullOfflineItemList.map(item => {
            item.offline = false
            return item
          })
        )
      } else {
        itemList = this.itemList.map(item => {
          item.online = true
          return item
        })
        itemList.concat(
          this.offlineItemList.map(item => {
            item.offline = false
            return item
          })
        )
      }
      return itemList
    }
  },
  watch: {
    currentFolder: function () {
      this.currentFolderCopy = JSON.parse(JSON.stringify(this.currentFolder))
    },
    fullItemList: function () {
      if (!this.currentItem) {
        return
      }
      let newCurrentItem = this.fullItemList.find(item => item.id === this.currentItem.id)
      if (newCurrentItem) {
        this.currentItem = newCurrentItem
      }
    }
  },
  methods: {
    formatTime: function (stamp) {
      return formatTime(stamp)
    },
    backFormerLevel: function () {
      if (this.currentItem === null && this.currentFolder === null) {
        // back to the project list view
        this.$emit('back-to-list')
      } else if (this.currentFolder !== null && this.currentItem === null) {
        // back to project root from folder
        // this.currentFolder = null;
        this.$store.commit('updateCurrentFolder', null)
      } else if (this.currentFolder === null && this.currentItem !== null) {
        // back to  project root from item
        this.currentItem = null
      } else {
        // back to folder from item
        this.currentItem = null
      }
    },
    toFolder: function (folder) {
      if (folder.id) {
        // this.currentFolder = folder;
        this.$store.commit('updateCurrentFolder', folder)
        window.scrollTo(0, 0)
      } else {
        this.$message.error('Folder not exist any more')
      }
    },
    toItem: function (item) {
      if (item.id) {
        this.currentItem = item
        window.scrollTo(0, 0)
      } else {
        this.$message.error('Item not exist any more')
      }
    },
    activeIndependentItemPage: function (item) {
      if (item.id) {
        this.currentItem = item
        this.showIndependentItemPage = true
      } else {
        this.$message.error('Item not exist any more')
      }
    },
    navTo: function (level) {
      // console.log("nav to =>", level);
      switch (level) {
        case 'HOME':
          this.$store.commit('updateCurrentFolder', null)
          // this.currentFolder = null;
          this.currentItem = null
          this.$emit('back-to-list')
          break
        case 'PROJECT':
          this.$store.commit('updateCurrentFolder', null)
          // this.currentFolder = null;
          this.currentItem = null
          break
        case 'FOLDER':
          this.currentItem = null
          break
        default:
        // PASS
      }
    },
    addNew: function (step) {
      if (!this.canAdd) {
        this.$message({
          showClose: true,
          message: 'Can add item in measurement stage only.',
          type: 'error'
        })
        return
      }
      if (step) {
        this.addItemEnterStep = step
      }
      let that = this
      setTimeout(function () {
        that.showAddPopW = true
        that.showAddPop = true
      }, 180)
    },
    showAddPopFunc: function () {
      let that = this
      setTimeout(function () {
        that.showAddPopW = false
      }, 200)
      setTimeout(function () {
        that.showDesktopAdd = true
      }, 200)
    },
    editItem: async function () {
      // console.log("click edit button");
      let activeEditResult = this.$store.dispatch(
        'editItem',
        this.currentItem.id
      )
      if (activeEditResult.success) {
        // DO NOTHING, WAIT FOR EDITOR
      } else {
        this.openEditorError = activeEditResult.error
      }
    },
    refreshItem: function () {
      // console.log("refresh item data");
      this.currentItem.refreshing = true
      setTimeout(() => {
        let itemId = this.currentItem.id
        let items = this.$store.state.currentItems
        let offlineItems = this.$store.state.currentOfflineItems
        let remoteItem = items.find(item => {
          return item.id === itemId
        })
        if (remoteItem) {
          this.currentItem = remoteItem
        } else {
          let offlineItem = offlineItems.find(item => {
            return item.id === itemId
          })
          if (offlineItem) {
            this.currentItem = offlineItem
          }
        }
        this.currentItem.refreshing = false
      }, 1000)
    },
    // Folder Menu (do NOT reset the menu if selected operation need confirm, since menu target is still needed)
    openFolderMenu: function (folder) {
      this.showFolderMenu = true
      this.folderMenuTarget = folder
      this.resetItemMenu()
    },
    resetFolderMenu: function () {
      this.showFolderMenu = false
      this.folderMenuTarget = null
    },
    renameFolder: function () {
      this.showRenameFolderPop = true
      this.newFolderName = this.folderMenuTarget.name
      this.showFolderMenu = false
    },
    deleteFolder: function () {
      this.showDeleteFolderPop = true
      this.showFolderMenu = false
    },
    submitRenameFolder: async function () {
      if (!this.newFolderName) {
        this.showRenameFolderPop = false
        this.resetFolderMenu()
        return
      }
      let folder = this.folderMenuTarget
      folder.name = this.newFolderName
      let editResult = await this.$store.dispatch('setFolder', folder)
      if (editResult.success) {
        this.$message.success('Name saved')
      } else {
        this.$message.error(editResult.error)
      }
      this.showRenameFolderPop = false
      this.resetFolderMenu()
    },
    cancelRenameFolder: function () {
      this.showRenameFolderPop = false
      this.resetFolderMenu()
      this.newFolderName = ''
    },
    submitDeleteFolder: async function () {
      let folder = this.folderMenuTarget
      folder.open = false
      let editResult = await this.$store.dispatch('setFolder', folder)
      if (editResult.success) {
        this.$message.success('Deleted')
      } else {
        this.$message.error(editResult.error)
      }
      this.showDeleteFolderPop = false
      this.resetFolderMenu()
    },
    cancelDeleteFolder: function () {
      this.showDeleteFolderPop = false
      this.resetFolderMenu()
    },
    saveEditImage: async function () {
      let saveResult = await this.$store.dispatch(
        'setFolder',
        this.currentFolderCopy
      )
      if (saveResult.success) {
        this.$message.success('Saved')
      } else {
        this.$message.error('Unable to save image, please try again later.')
      }
      this.currentFolderCopy = JSON.parse(JSON.stringify(this.currentFolder))
    },
    cancelEditImage: function () {
      this.currentFolderCopy = JSON.parse(JSON.stringify(this.currentFolder))
    },
    // item menu (do NOT reset the menu if selected operation need confirm, since menu target is still needed)
    openItemMenu: function (item) {
      this.showItemMenu = true
      this.itemMenuTarget = item
      this.resetFolderMenu()
    },
    resetItemMenu: function () {
      this.showItemMenu = false
      this.itemMenuTarget = null
    },
    editItemMenu: function () {
      this.$store.dispatch('editItem', this.itemMenuTarget.id)
      window.scrollTo(0, 0)
      this.resetItemMenu()
    },
    deleteItem: function () {
      this.showDeleteItemPop = true
      this.showItemMenu = false
    },
    submitDeleteItem: async function () {
      let item = this.itemMenuTarget
      let editResult = await this.$store.dispatch('deleteItem', item)
      if (editResult.success) {
        this.$message.success('Deleted')
      } else {
        this.$message.error(editResult.error)
      }
      this.showDeleteItemPop = false
      this.resetItemMenu()
    },
    cancelDeleteItem: function () {
      this.showDeleteItemPop = false
      this.resetItemMenu()
    }
  }
}

function formatTime (stamp) {
  let stampObj = new Date(stamp)
  let currentObj = new Date(Date.now())
  let day = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  let stampDate = {
    year: stampObj.getFullYear(),
    month: stampObj.getMonth() + 1,
    date: stampObj.getDate(),
    day: day[stampObj.getDay()],
    hour: stampObj.getHours(),
    minute: stampObj.getMinutes()
  }

  let currentDate = {
    year: currentObj.getFullYear(),
    month: currentObj.getMonth() + 1,
    date: currentObj.getDate(),
    day: day[currentObj.getDay()],
    hour: currentObj.getHours(),
    minute: currentObj.getMinutes()
  }

  if (
    stampDate.year === currentDate.year &&
    stampDate.month === currentDate.month &&
    stampDate.date === currentDate.date
  ) {
    return `${stampDate.hour}:${stampDate.minute}`
  } else if (
    stampDate.year === currentDate.year &&
    stampDate.month === currentDate.month &&
    Date.now() - stamp < 6 * 24 * 3.6e6
  ) {
    return `${stampDate.day}`
  } else if (stampDate.year === currentDate.year) {
    let option = { month: 'short', day: 'numeric' }
    return `${stampObj.toLocaleDateString('en-US', option)}`
  } else {
    let option = { month: 'short', day: 'numeric', year: 'numeric' }
    return `${stampObj.toLocaleDateString('en-US', option)}`
  }
}
</script>

<style scoped>
.pop {
  position: fixed;
  top: 15vh;
  left: 25vw;
  z-index: 2000;
  width: 50vw;
  margin: 0 auto 2vh auto;
  color: #333;
}

.project-buttons {
  /* text-align: right; */
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 12px 0 12px;
  margin: auto;
  max-width: 76vw;
}

.project-button {
  font-size: 24px;
  margin-right: 16px;
  box-sizing: border-box;
  padding: 4px;
  cursor: pointer;
  transition: all ease 0.2s;
}

.folder-size-bubble {
  color: #ffffff;
  display: inline-block;
  background-color: #e21515;
  border-radius: 12px;
  height: 24px;
  width: 24px;
  font-size: 18px;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
  margin-left: 12px;
  line-height: 24px;
}

.image-light-box {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  cursor: zoom-in;
}

.project-home-w {
  margin-top: 24px;
}
.more-button {
  display: inline-block;
  width: 32px;
  box-sizing: border-box;
  padding: 4px;
  margin-left: 8px;
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}

.item-viewer-w {
  font-size: 16px;
  font-weight: bold;
}

.breadcrumb-w {
  min-height: 48px;
  display: flex;
  margin-left: 12vw;
  width: 76vw;
}
.bread-item {
  font-size: 18px;
  line-height: 48px;
  cursor: pointer;
  margin: 0 6px;
}
.back-w {
  font-size: 24px;
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  padding: 12px;
  margin-right: 6px;
}
.folder-name {
  width: 100%;
  height: 48px;
}
.item-name {
  width: 100%;
  height: 48px;
}
.project-list-w {
  padding: 0 0 60px 0;
  box-sizing: border-box;
}
.project-list {
  box-sizing: border-box;
  padding: 0 12% 16px 12%;
}
#item-page-w {
  box-sizing: border-box;
  padding: 0 12% 16px 12%;
  width: 100vw;
  border-radius: 20px;
  background-color: #ffffff;
  padding: 20px;
  border: solid 1px #f0f0f0;
  max-width: 76vw;
  margin: 16px auto 0 auto;
}
.project-card {
  width: 23vw;
  /* height: 64px;
  padding: 12px;
  border-radius: 6px; */
}
.last-edit-by {
  font-size: 10px;
  line-height: 20px;
  /* color: #808080; */
  /* color: #107BE8; */
  color: #1e88e5;
  margin-top: 12px;
  font-weight: 500;
}
.project-name {
  width: calc(23vw - 40px);
  max-width: calc(23vw - 40px);
  display: flex;
  align-items: center;
}
.project-name-text {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  width: calc(23vw - 80px);
  max-width: calc(23vw - 80px);
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.folder-name-text {
  max-width: calc(23vw - 116px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-name-text {
  width: calc(23vw - 105px);
  max-width: calc(23vw - 105px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.section-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 48px;
  margin: 4px 24px 4px 28px;
  color: #808080;
}
.no-item-tip {
  margin-left: 2vw;
}
.no-folders-tip {
  margin-left: 2vw;
}

@media screen and (max-width: 991px) {
  .pop {
    width: 75vw;
    left: 12.5vw;
  }
  .project-home-w {
    margin-top: 16px;
  }
  .breadcrumb-w {
    min-height: 48px;
    display: flex;
    margin-left: 0;
    box-sizing: border-box;
    padding: 0 16px;
    width: 100%;
  }
  .bread-item {
    font-size: 16px;
  }
  .project-list-w {
    display: block;
    box-sizing: border-box;
    padding: 0 0 40px 0;
  }
  .project-list {
    width: 100%;
    padding: 0 16px 0 16px;
    box-sizing: border-box;
  }
  #item-page-w {
    width: calc(100vw - 32px);
    margin: 16px auto 16px auto;
    box-sizing: border-box;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 20px;
    max-width: calc(100vw - 32px);
    border: solid 1px #f0f0f0;
  }
  .project-buttons {
    text-align: right;
    box-sizing: border-box;
    padding: 12px 16px 0 12px;
    max-width: calc(100vw - 32px);
  }
  .project-card {
    width: calc(50vw - 32px);
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 20px;
    display: inline-block;
    /* border: solid 1px black; */
  }
  .project-name {
    /* width: calc(44.5vw - 40px);
    max-width: calc(44.5vw - 80px); */
    width: calc(50vw - 72px);
    max-width: calc(50vw - 72px);
  }
  .project-name-text {
    width: calc(50vw - 120px);
    max-width: calc(50vw - 120px);
  }
  .folder-name-text {
    max-width: calc(50vw - 156px);
  }
  .item-name-text {
    width: calc(50vw - 145px);
    max-width: calc(50vw - 145px);
  }
  .section-title {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media screen and (max-width: 500px) {
  .pop {
    width: 90vw;
    left: 5vw;
  }
  .breadcrumb-w {
    margin-left: 0;
    width: 100vw;
  }
  .project-card {
    width: calc(100vw - 32px);
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 12px;
    display: inline-block;
    /* border: solid 1px black; */
  }
  .project-name {
    width: calc(100vw - 80px);
    max-width: calc(100vw - 80px);
  }
  .project-name-text {
    width: calc(100vw - 120px);
    max-width: calc(100vw - 120px);
  }
  .folder-name-text {
    max-width: calc(100vw - 156px);
  }
  .item-name-text {
    width: calc(100vw - 145px);
    max-width: calc(100vw - 145px);
  }
  .section-title {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media screen and (max-width: 350px) {
  .pop {
    top: 3vh;
    width: 90vw;
    left: 5vw;
  }
}
</style>
